import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

// POST /api/admin/tiers/programs/:id/archive
//
// Pessimistic. Archiving the default is allowed (the 0038 sync trigger
// no-ops when no default exists) so we invalidate `partners.all` as well —
// partner cards may now resolve to a different default program (or none).
export function useArchiveTierProgram() {
  const queryClient = useQueryClient();
  return useMutation<{ ok: true }, ApiClientError, { id: string }>({
    mutationFn: ({ id }) =>
      apiFetch<{ ok: true }>(`/admin/tiers/programs/${id}/archive`, {
        method: "POST",
      }),
    onSuccess: (_data, { id }) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.tiers.programs.list() });
      queryClient.invalidateQueries({ queryKey: queryKeys.tiers.program(id) });
      queryClient.invalidateQueries({ queryKey: queryKeys.partners.all });
      // Phase 7 sub-bucket 13 carry-over fix. Archiving a tier program
      // (especially the default) shifts what the dashboard's "Default
      // program" card resolves to; refresh that surface immediately.
      queryClient.invalidateQueries({ queryKey: queryKeys.admin.dashboard() });
    },
    onError: (err) => {
      toast.error(err.message ?? "Failed to archive tier program");
    },
  });
}
